// extracted by mini-css-extract-plugin
export default {"wrapper":"ZvmcNnXFGl3R3v6YIhNJ typography-body","item":"y98cfSNdkSnv1oNN5Tyh","chevron":"FybNmnbgnJBtGBCcFBcY"};